import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-pin-icon',
  standalone: true,
  templateUrl: './pin-icon.component.html',
  styleUrls: ['./pin-icon.component.scss']
})
export class PinIconComponent {
  @Input() width: number | string = 16;
  @Input() height: number | string = 16;
}
